import { Component, Input, Output, EventEmitter } from '@angular/core';
import { LucideAngularModule } from 'lucide-angular';
import { TranslatePipe } from '@shared/pipes/translate.pipe';

/**
 * Bell dropdown listing notification categories (US 59875). Currently a
 * single "Comunicação de Times" entry that emits `navigate` when picked —
 * the host (header) owns routing and closing. Extensible: a new category is
 * a new `.notif-item`; the footer hides once two or more items exist.
 */
@Component({
  selector: 'app-notification-bell-dropdown',
  standalone: true,
  imports: [LucideAngularModule, TranslatePipe],
  templateUrl: './notification-bell-dropdown.component.html',
  styleUrl: './notification-bell-dropdown.component.scss'
})
export class NotificationBellDropdownComponent {
  /** Unread count shown on the "Comunicação de Times" item (inbox + archived). */
  @Input() communicationCount = 0;

  /** Emitted when a category item is selected; host navigates and closes. */
  @Output() navigate = new EventEmitter<void>();

  /** Number of categories currently rendered. Drives footer visibility. */
  readonly itemCount = 1;

  onCommunicationClick(): void {
    this.navigate.emit();
  }
}
